import React from 'react'
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import EventApi from "../../../../Api/EventApi";
import {getApiHost, getResponseError, getUserDetailsCookie, storeEventsInSession} from "../../../../Api/Utils/apiUtils";
import GridContainer from "../../../../Components/Form/GridContainer/GridContainer";
import {formatDisplayDate, formatTime} from "../../../../Api/Utils/dateUtils";
import "../../../../bootstrap/bootstrap.min.css";
import {useHistory} from "react-router-dom";
import '../../../../Components/Form/Form.css'
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";

const ManageEventComponent = () => {
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [events, setEvents] = React.useState([]);
    React.useEffect(() => {
        const loadEventDetails = async () => {
            const user = getUserDetailsCookie();
            const response = await EventApi.getEvent(user.id);
            const apiError = getResponseError(response);
            if(apiError){
                setErrorMessage(apiError);
            } else {
                const events = response.objectVal;
                events.forEach(e => {
                    e.eventImageInformationSet.forEach(img => {
                        let imageUrl = img.imageUrl;
                        if (imageUrl.indexOf('upload') === 0) {
                            imageUrl = getApiHost() + '/' + imageUrl;
                        }
                        img.url = imageUrl;
                    });
                });
                setEvents(events);
                storeEventsInSession(events);
            }
        };
        loadEventDetails();
    }, []);

    const history = useHistory();
    const showEventDetails = eventId =>{
        history.push("/event-details/"+eventId);
    }

    return (
        <Section>
            <FormContainer>
                <Heading>Manage events</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <GridContainer itemsPerRow={2}>
                    {events && events.length > 0 && events.map(( event , index) =>
                        <div className="grid-image grid-image-border-bottom" key={index} onClick={() => showEventDetails(event.id)}>
                            <img src={event.eventImageInformationSet[0] && event.eventImageInformationSet[0].url} alt='no-alt' />
                            <p className="event-name">{event.eventName && event.eventName}</p>
                            <div className="event-date-time">
                                <span>{formatDisplayDate(event.eventDate && event.eventDate)}</span>
                                <span style={{float: 'right'}}>{formatTime(event.eventTime && event.eventTime)}</span>
                            </div>
                        </div>
                    )}
                </GridContainer>
            </FormContainer>
        </Section>
    )
}

export default ManageEventComponent
